import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const OmanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15684'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15684)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#138E16'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V9.33333H20V4.66667H6.66667V0H0V14Z'
					fill='#ED2B35'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.3325 3.29825L2.50605 4.48182L2.93501 3.11066L1.47549 3.21539L2.83684 2.68915L1.84329 1.63617L3.11191 2.35113L3.3325 0.93335L3.55308 2.35113L4.8217 1.63617L3.82815 2.68915L5.1895 3.21539L3.72998 3.11066L4.15894 4.48182L3.3325 3.29825Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default OmanFlagIcon;
